export default __webpack_public_path__ + "9f87e7f95e944f50b35fbcef4b394543.png";